/** UI lifecycle hint only. The backend and AgentServer still verify all credentials. */
export function agentPrincipalHint(token: string | null, loggedIn: boolean): string | null {
  if (!loggedIn || !token || token.length > 8192) return null;
  try {
    const parts = token.split(".");
    if (parts.length !== 3 || parts[1].length > 4096) return null;
    const body = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));
    return body.typ === "access" &&
      typeof body.sub === "string" &&
      /^[1-9][0-9]{0,18}$/.test(body.sub)
      ? body.sub
      : null;
  } catch {
    return null;
  }
}

export interface AgentIdentityRequest {
  integration: string;
  revision: number;
  parentOrigin: string;
  nonce: string;
  audience: string;
  credentialPath: string;
}
export function validAgentIdentityRequest(
  request: AgentIdentityRequest,
  integration: string,
  parentOrigin: string,
  agentOrigin: string,
): boolean {
  return (
    request.integration === integration &&
    Number.isSafeInteger(request.revision) &&
    request.revision > 0 &&
    request.parentOrigin === parentOrigin &&
    request.audience === `${agentOrigin}/embed/v1/identity` &&
    request.credentialPath === "/api/v1/agent/identity" &&
    /^[A-Za-z0-9_-]{42}[AEIMQUYcgkosw048]$/.test(request.nonce)
  );
}

/** Explicit build-time local replica scope; never widens a deployed profile. */
export function validAgentOrigin(origin: string, allowHttpLoopback = false): boolean {
  try {
    const url = new URL(origin);
    if (url.origin !== origin || url.username || url.password) return false;
    if (url.protocol === "https:") return true;
    return allowHttpLoopback && url.protocol === "http:" &&
      ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname) &&
      Number(url.port) >= 1024 && Number(url.port) <= 65535;
  } catch { return false; }
}
